import React from 'react';
import {SmallUnderline} from "../../styles/components/SmallUnderline";
import {Button} from "../button/Button";
import { Row, Col, Container } from 'reactstrap';
import { Link } from "../link/Link";
import {BasicAnimation} from "../animations/BasicAnimation";
import {Helmet} from "react-helmet";

export class AboutUs extends React.Component {

  render(){
    if(!this.props.data)
      return null;

    return (
      <div className="about-us-container obelux-background">
      <Helmet>
          <meta name="description" content="Obelux designs, manufactures, and sells ICAO and FCAA compliant LED aviation obstruction lights."></meta>
          <meta name="og:description" content="Obelux designs, manufactures, and sells ICAO and FCAA compliant LED aviation obstruction lights."></meta>
      </Helmet>
        <BasicAnimation duration={500} delay={100}>
        <Container>
          <Row>
            <Col xs="12" md="7" className="py-5">

              <SmallUnderline align="left">
                <h2>About Us</h2>
              </SmallUnderline>
              <div dangerouslySetInnerHTML={{
                __html: this.props.data.content
              }}/>
              <Link to="/about">
                <Button size={"sm"}>Read More</Button>
              </Link>
            </Col>
            <Col xs="5" className="d-none d-md-block background-image"
                 style={{ backgroundImage: `url(${this.props.data.image.url})` }}/>
          </Row>
        </Container>
        </BasicAnimation>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/about-us/AboutUs.js